<template>
  <div class="toast-wrapper">
    <div class="card card-glass toast">
      <div class="toast-icon">
        <AppIcon :type="toast.type || 'info'" :class="'color-'+toast.type" />
      </div>
      <div class="toast-content">
        <h4 :class="'color-'+toast.type">{{ toast.title }}</h4>
        <p v-if="toast.msg" v-html="toast.msg"></p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Toast } from '@/api/models/Toast'
import { defineComponent, PropType, ref } from 'vue'

export default defineComponent({
  name: 'AppToast',
  props: {
    toast: {
      type: Object as PropType<Toast>
    }
  },
  setup() {
    const hide = ref(false)

    return { hide }
  }
})
</script>

<style lang="scss" scoped>
.toast-wrapper {
  position: absolute; 
  left: 0; 
  right: 0; 
  top: 0;
  display: flex;
  justify-content: center;
  pointer-events: none;
}
.toast {
  display: inline-flex;
  min-width: 20rem;
  padding: 1rem 2.5rem 1rem 1.25rem !important;
  border-radius: 1.5rem !important;
  margin-top: .25rem;
  max-width: 30rem;
  pointer-events: all;
  transition: transform .3s, opacity .3s;

  &-icon {
    flex: 2.5rem 0 0;
  }

  &-content {
    
  }

  h4 {
    white-space: nowrap;
    margin: 0;
    line-height: 1.5rem;
  }

  p {
    margin: 0;
    margin-top: .25rem;
    font-size: .875rem;
  }
}
@media only screen and (max-width: 480px) {
  .toast-wrapper {
    top: unset;
    bottom: 0;
  }
  .toast {
    max-width: 100%;
    h4 {
      white-space: normal;
    }
  }
}
</style>